// ABOUTME: Shared Adhesive Calculator Core
// ABOUTME: Provides reusable adhesive calculation and recommendation logic
class AdhesiveCalculatorCore {

  /**
   * Get adhesive recommendations for a given anchor product and quantity
   * @param {string|number} anchorProductId - The anchor product ID
   * @param {number} anchorQuantity - Number of anchors needed
   * @returns {Array} Array of adhesive recommendations with calculated quantities
   */
  static getAdhesiveRecommendations(anchorProductId, anchorQuantity = 1) {
    if (window.adhesiveCalculatorData &&
        Array.isArray(window.adhesiveCalculatorData.adhesiveProducts) &&
        window.adhesiveCalculatorData.adhesiveProducts.length > 0 &&
        (window.adhesiveCalculatorData.currentAnchor ||
          (Array.isArray(window.adhesiveCalculatorData.anchorProducts) && window.adhesiveCalculatorData.anchorProducts.length > 0))) {
      return window.AacCommerceDomain.adhesiveRecommendations(
        window.adhesiveCalculatorData,
        anchorProductId,
        anchorQuantity
      );
    }

    console.warn('No adhesive calculation data available');
    return [];
  }

  static _findAnchorData(anchorProductId) {
    return window.AacCommerceDomain.findAnchor(window.adhesiveCalculatorData, anchorProductId);
  }

  /**
   * Get recommendations using metafield-based data structure
   * @private
   */
  static _getRecommendationsFromMetafields(anchorProductId, anchorQuantity) {
    return window.AacCommerceDomain.adhesiveRecommendations(
      window.adhesiveCalculatorData,
      anchorProductId,
      anchorQuantity
    );
  }

  /**
   * Format money amount using Shopify's format
   * @param {number} cents - Price in cents
   * @returns {string} Formatted price string
   */
  static formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  /**
   * Update adhesive recommendations when anchor quantity changes
   * @param {Array} recommendations - Original recommendations array
   * @param {number} newAnchorQuantity - New anchor quantity
   * @param {number} anchorProductId - The anchor product ID (needed for metafield-based recalc)
   * @returns {Array} Updated recommendations with recalculated quantities
   */
  static updateQuantities(recommendations, newAnchorQuantity, anchorProductId = null) {
    if (anchorProductId && window.adhesiveCalculatorData && window.adhesiveCalculatorData.anchorProducts) {
      return window.AacCommerceDomain.updateRecommendationQuantities(
        window.adhesiveCalculatorData,
        recommendations,
        newAnchorQuantity,
        anchorProductId
      );
    }

    return recommendations;
  }

  static getLowestTotalVariantIdsByProduct(recommendations) {
    return window.AacCommerceDomain.lowestTotalVariantIdsByProduct(recommendations);
  }
}

// Make available globally
window.AdhesiveCalculatorCore = AdhesiveCalculatorCore;
